import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Create axios instance with interceptors
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const fetchProjects = createAsyncThunk(
  'projects/fetchProjects',
  async ({ page = 1, limit = 10, search = '', status = '', userId = '' }) => {
    try {
      const response = await api.get(`/api/projects?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}&status=${status}&userId=${userId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
);

export const fetchProjectById = createAsyncThunk(
  'projects/fetchProjectById',
  async (id) => {
    try {
      const response = await api.get(`/api/projects/${encodeURIComponent(id)}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
);

export const createProject = createAsyncThunk(
  'projects/createProject',
  async (projectData) => {
    try {
      const response = await api.post('/api/projects', projectData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
);

export const updateProject = createAsyncThunk(
  'projects/updateProject',
  async ({ id, projectData }) => {
    try {
      const response = await api.put(`/api/projects/${encodeURIComponent(id)}`, projectData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
);

export const deleteProject = createAsyncThunk(
  'projects/deleteProject',
  async (id) => {
    try {
      await api.delete(`/api/projects/${encodeURIComponent(id)}`);
      return id;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
);

export const fetchUserProjects = createAsyncThunk(
  'projects/fetchUserProjects',
  async (userId) => {
    try {
      const response = await api.get(`/api/projects/user/${encodeURIComponent(userId)}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
);
